import axios from "axios";

// export const getAll = async (page, dispatchApi) => {
//   axios.get(`users?page=${page}`).then(({ data }) =>
//     dispatchApi({
//       type: "FETCHED_USER",
//       data,
//     })
//   );
// };
// eslint-disable-next-line import/prefer-default-export
export const subscribe = (userId, subscription) =>
  axios.post(`subscribe?userId=${userId}`, subscription);
